import { Box } from '@machobear/design-system'

import { ReactNode } from 'react'

import useMediaQuery from '@/hooks/use-media-query'
import { breakpoints, structure } from '@/styles'
import * as styles from './index.css'

const MyListingsHeaderWrapper = ({
  height = 282,
  title,
  children,
  isIntegrationTabSelected
}: {
  height?: number
  title: string
  children: ReactNode
  isIntegrationTabSelected: boolean
}) => {
  const displayBelowTablet = useMediaQuery(`(max-width: ${breakpoints.tabletLandscape})`)

  return (
    <Box
      padding="none"
      position="sticky"
      width="full"
      background="white"
      className={styles.listingsHeaderWrapperStyle}
    >
      {!displayBelowTablet && (
        <Box
          display="flex"
          justifyContent="center"
          flexDirection="row"
          background={isIntegrationTabSelected ? 'formAccentSoft' : 'neutralLight'}
        >
          <Box
            display="flex"
            flexDirection="column"
            position="relative"
            className={styles.pageHeaderExtraInner}
          >
            <Box as="h1" paddingY="xsmall" className={styles.headerTitleStyle}>
              {title}
            </Box>
          </Box>
        </Box>
      )}

      {children}
    </Box>
  )
}

export default MyListingsHeaderWrapper
